module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "missionSponsors"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("Mission Sponsors")]), _vm._v(" "), _vm._l((_vm.sponsors), function(location) {
    return _c('div', [_c('h3', {
      domProps: {
        "innerHTML": _vm._s(location.location)
      }
    }), _vm._v(" "), _vm._l((location.sponsors), function(sponsor) {
      return _c('div', {
        staticClass: "sponsor"
      }, [_c('div', {
        staticClass: "logo"
      }, [_c('img', {
        staticClass: "img-fluid",
        attrs: {
          "src": sponsor.logo.sizes.medium
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "content"
      }, [_c('p', [_c('strong', {
        staticClass: "upcase"
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(sponsor.sponsor_type)
        }
      }), _vm._v(":")]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(sponsor.description)
        }
      })])])])
    })], 2)
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-439c1512!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OurTeam/MissionSponsors.vue
// module id = 314
// module chunks = 1